<template>
  <div class="take-explain-box">
    <div class="take-explain-info hyphenate-text">
      {{
        $t('FoodC_subscription_eceZ_mHfd', {
          date: membership.renewDate,
          money: membership.renewPriceSplit.display,
        })
      }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    membership: {
      default: () => {},
      type: Object,
    },
  },
}
</script>

<style lang="scss" scoped>
.take-explain-box {
  margin-top: 48px;
  padding: 0 40px 220px 40px;
  .take-explain-info {
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #0b0b0d;
    line-height: 42px;
    font-weight: 400;
    .rule {
      font-family: DiDiSans-Pro-Bold;
      font-size: 28px;
      color: #0b0b0d;
      line-height: 42px;
      font-weight: 700;
      text-decoration: underline;
    }
  }
}
</style>
